import { Component, EventEmitter } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { ModalService } from '@core/services/modal.service'
import { NotificationService } from '@core/services/notification.service'

@Component({
	selector: 'app-order-delivery',
	templateUrl: './order-delivery.component.html',
	styleUrl: './order-delivery.component.scss',
})
export class OrderDeliveryComponent {
	form = new FormControl<'selected' | 'unselected' | null>('unselected', Validators.required)
	onSubmit: EventEmitter<'selected' | 'unselected' | null> = new EventEmitter()
	protected readonly textHasDeliveryConfirmation = $localize`Delivery confirmation`

	constructor(
		private modalService: ModalService,
		private notificationService: NotificationService,
	) {}

	submit(): void {
		const instance = this.modalService.modalRef?.componentInstance
		if (!instance) {
			console.error('Create a handler for this use scenario')
			return
		}

		if (this.form.invalid) {
			this.notificationService.warning($localize`Please select directory first`)
			return
		}

		this.onSubmit.emit(this.form.value)
	}
}
